import { Dialog, Markdown, useText } from "@sveabank/cc-common";
import type React from "react";
import FinalizeButtonGroup from "./finalize-button-group";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
};

const FinalizeModalMissingBo: React.FC<Props> = ({ isOpen, setOpen }) => {
	const [t, texts] = useText();

	return (
		<Dialog
			size="small"
			center
			isOpen={isOpen}
			setOpen={setOpen}
			heading={t(texts.modals.finalizeMissingBo.title)}
			icon="warning"
		>
			<Dialog.Content>
				<Markdown allowParagraphs>{t(texts.modals.finalizeMissingBo.body)}</Markdown>
			</Dialog.Content>
			<FinalizeButtonGroup onClose={() => setOpen(false)} />
		</Dialog>
	);
};

export default FinalizeModalMissingBo;
